class MarqueeObserver {
    constructor() {
        this.subscribers = new Set();
    }

    subscribe(callback) {
        this.subscribers.add(callback);
        return () => this.subscribers.delete(callback);
    }

    notify(data) {
        this.subscribers.forEach(callback => callback(data));
    }
}

const marqueeObserver = new MarqueeObserver();

class MarqueeToggleButton extends HTMLElement {
    constructor() {
        super();
        this.isActive = false;
    }

    connectedCallback() {
        this.innerHTML = this.getAttribute('text') || 'SITE CREDITS';
        this.className = 'marquee-toggle-btn';
        this.setAttribute('role', 'button');
        this.setAttribute('tabindex', '0');

        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    handleClick(e) {
        e.preventDefault();
        this.toggle();
    }

    handleKeydown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggle();
        }
    }

    toggle() {
        this.isActive = !this.isActive;
        this.classList.toggle('is-active', this.isActive);

        marqueeObserver.notify({
            type: 'toggle',
            isActive: this.isActive
        });
    }
}

class MarqueeBar extends HTMLElement {
    constructor() {
        super();
        this.isVisible = false;
        this.unsubscribe = null;
    }

    connectedCallback() {
        this.className = 'footer-marquee-bar';
        this.setupStyles();
        this.setupContent();

        this.unsubscribe = marqueeObserver.subscribe(this.handleObserverEvent.bind(this));
    }

    disconnectedCallback() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    setupStyles() {
        const speed = this.getAttribute('speed') || '20s';
        const bgColor = this.getAttribute('bg-color') || '#000000';
        const textColor = this.getAttribute('text-color') || '#ffffff';

        this.style.setProperty('--marquee-speed', speed);
        this.style.setProperty('--marquee-bg-color', bgColor);
        this.style.setProperty('--marquee-text-color', textColor);
    }

    setupContent() {
        let items = [];
        try {
            items = JSON.parse(this.getAttribute('items')) || [];
        } catch (e) {
            items = [];
        }
        if (!Array.isArray(items) || items.length === 0) {
            this.innerHTML = '';
            return;
        }
        this.innerHTML = `
      <div class="marquee-container">
        <div class="marquee-text" style="color: var(--marquee-text-color);">
          ${items.map(item => {
            if (item.link) {
                return `<a href="${item.link}" target="_blank" style="color: inherit; text-decoration: none;">${item.text.toUpperCase()}</a>`;
            } else {
                return `<span>${item.text.toUpperCase()}</span>`;
            }
          }).join('')}
        </div>
      </div>
    `;
    }

    handleObserverEvent(data) {
        if (data.type === 'toggle') {
            this.toggleVisibility(data.isActive);
        }
    }

    toggleVisibility(show) {
        this.isVisible = show;
        this.classList.toggle('active_marquee', show);

        if (show) {
            document.body.style.paddingBottom = '50px';
        } else {
            document.body.style.paddingBottom = '0';
        }
    }

    show() {
        this.toggleVisibility(true);
    }

    hide() {
        this.toggleVisibility(false);
    }
}

customElements.define('marquee-toggle-btn', MarqueeToggleButton);
customElements.define('marquee-bar', MarqueeBar);

window.MarqueeComponents = {
    MarqueeToggleButton,
    MarqueeBar,
    marqueeObserver
};

document.addEventListener('DOMContentLoaded', () => {
    const handleAnchorClick = (e) => {
      const anchor = e.target.closest('a[href="#site-credits"]');
      if (anchor) {
        e.preventDefault();
  
        marqueeObserver.notify({
          type: 'toggle',
          isActive: !document.querySelector('marquee-bar')?.classList.contains('active_marquee')
        });
  
        const target = document.querySelector('#site-credits');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };
  
    document.body.addEventListener('click', handleAnchorClick);
  });
